import NavBarHome from "../components/NavBarHome";
import Client_Frame from "../components/Client_Frame";
import Address_Frame from "../components/Address_Frame";
import Testimonial_Frame from "../components/Testimonial_Frame";

const HomePage = () => {
  return (
    <div className="w-full relative bg-white min-h-screen text-left text-[44px] text-gray-300 font-istok-web">
      <NavBarHome
        navBarHomeWidth="1690px"
        navBarHomePosition="absolute"
        navBarHomeTop="50px"
        navBarHomeLeft="113px"
        navBarHomeAlignSelf="unset"
      />

      {/* <b className="absolute top-[1106px] left-[55px] leading-[100%] uppercase [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]">
        Discover our services and start building your dream team today!
      </b> */}

      {/* <div className="absolute top-[211px] left-[130px] w-[1540px] h-[808px] flex flex-col items-start justify-start py-[124px] px-[71px] box-border bg-[url('/public/hand-shake@3x.png')] bg-cover bg-no-repeat bg-[top] text-11xl text-white">
        <div className="w-[798px] h-[464px] flex flex-col items-center justify-center gap-[26px]">
          <div className="w-[807px] relative uppercase text-center inline-block">
            Your Trusted Partner in Recruitment Solutions
          </div>
          <b className="w-[783px] relative text-[62px] leading-[100%] uppercase inline-block h-[165px] shrink-0 [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0.25)]">
            Connecting Talent with Opportunity
          </b>
          <div className="w-[791px] relative text-[26px] capitalize inline-block">
            StaffSurge Consultancy Pvt. Ltd. is a leading recruitment
            consultancy committed to matching top-tier talent with dynamic
            organizations across industries. With over 2+ years of experience
            and a portfolio of satisfied clients, we specialize in delivering
            customized staffing solutions that drive growth and innovation.
          </div>
        </div>
      </div> */}

      <div className="box-border bg-[url('/public/hand-shake@3x.png')] bg-cover bg-no-repeat bg-[top] text-11xl text-white px-12 py-16 lg:h-[980px]">
        <div className="text-6xl xl:text-11xl w-1/2">
          Your Trusted Partner in Recruitment Solutions
        </div>
        <div className="uppercase font-bold py-4 text-21xl xl:text-35xl w-1/2">
          Connecting Talent with Opportunity
        </div>
        <div className="text-6xl xl:text-11xl w-1/2">
          StaffSurge Consultancy Pvt. Ltd. is a leading recruitment consultancy
          committed to matching top-tier talent with dynamic organizations
          across industries. With over 2+ years of experience and a portfolio of
          satisfied clients, we specialize in delivering customized staffing
          solutions that drive growth and innovation.
        </div>
      </div>

      <div className="mt-4 px-8 text-center">
        Discover our services and start building your dream team today!
      </div>

      <div className="px-12">
        <Client_Frame />
      </div>

      <div className="px-12">
        <Testimonial_Frame />
      </div>

      <div>
        <Address_Frame />
      </div>
    </div>
  );
};

export default HomePage;
